import React from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-web';

interface MessageUsButtonProps {
  trackMessageUsLink: () => void;
}

const MessageUsButton = ({ trackMessageUsLink }: MessageUsButtonProps) => {
  return (
    <ButtonPrimary href="/contact-spotify-support/" buttonSize="sm" onClick={trackMessageUsLink}>
      {/* {t('feedback_contact_us_link')}*/}
      Message us
    </ButtonPrimary>
  );
};

export default MessageUsButton;
